/*doc

 Contains the list of featured authors.
 Store is populated with list of authors plus
 relevant data.

 */

import Reflux from "reflux";
import AskTheAuthorFeaturedAuthorsActions from "../react_actions/ask_the_author/featured_authors_actions";
import Freezer from "freezer-js";
import { each } from "lodash";

const state = new Freezer({
  authors: [],
  total: 0,
});

let fullFeaturedAuthorsList = [];

const DEFAULT_INITIAL_LIST_SIZE = 3;
const LOAD_MORE_SIZE = 3;

export default Reflux.createStore({
  listenables: [AskTheAuthorFeaturedAuthorsActions],

  DEFAULT_INITIAL_LIST_SIZE,
  LOAD_MORE_SIZE,
  fullFeaturedAuthorsList,

  init() {
    this.getState().set({ authors: [], total: 0 });
    fullFeaturedAuthorsList = [];
  },

  getState() {
    return state.get();
  },

  getInitialState() {
    return this.getState();
  },

  reset() {
    this.getState().reset({});
    fullFeaturedAuthorsList = [];
  },

  populateList(authorData) {
    const numFeaturedAuthors = authorData.length;
    fullFeaturedAuthorsList = [];
    each(authorData, (singleAuthorData) => {
      fullFeaturedAuthorsList.push({ name : singleAuthorData.author.name,
                                     id : singleAuthorData.author.id,
                                     profileUrl :singleAuthorData.author.profileUrl,
                                     profileImage : singleAuthorData.author.profileImage,
                                     authorTagline : singleAuthorData.authorTagline,
                                     questionURL : singleAuthorData.questionURL,
                                     answerURL : singleAuthorData.answerURL,
                                     answersCount : singleAuthorData.answersCount,
                                     ATAenabled : singleAuthorData.ATAenabled });
    });
    if (numFeaturedAuthors > 0) {
      let authors_list = fullFeaturedAuthorsList;
      if (numFeaturedAuthors > DEFAULT_INITIAL_LIST_SIZE){
        authors_list = authors_list.slice(0, DEFAULT_INITIAL_LIST_SIZE);
      }
      this.getState().set({ authors: authors_list, total: numFeaturedAuthors });
    }
  },

  onLoadMoreFeaturedAuthors() {
    const state = this.getState();
    let authorList = state.authors;
    const authorListLength = authorList.length;
    const totalAuthors = state.total;
    const toAdd = Math.min(LOAD_MORE_SIZE, (totalAuthors-authorList.length));
    for (let i=authorListLength; i<(authorListLength+toAdd); i++){
      const anotherAuthor = fullFeaturedAuthorsList[i];
      authorList = authorList.push(anotherAuthor);
    }
    this.getState().set({ authors: authorList });
    this.trigger(this.getState());
  },
});
